import React, { Component, Suspense } from "react";
import classes from "./Body.module.css";

import { connect } from "react-redux";

class Body extends Component {
  render() {
    let plComponent;
    let lastString = this.props.tabName;
    let path = this.props.path;

    if (lastString !== null) {
      lastString = lastString.replace(/\s/g, "");
      path = path.replace(/\s/g, "");
      const URL = path + "/" + lastString + "/" + lastString;
      const NewComponent = React.lazy(() =>
        import("../../components/BodyComponents/" + URL)
      );
      plComponent = (
        <Suspense fallback={<div>Loading</div>}>
          <NewComponent></NewComponent>
        </Suspense>
      );
    } else {
      plComponent = <div>Empty</div>;
    }

    return <div className={classes.Body}>{plComponent}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    tabName: state.bdRed.tabName,
    path: state.actRed.name,
  };
};

export default connect(mapStateToProps)(Body);
